import { render, staticRenderFns } from "./abstractCamera.vue?vue&type=template&id=a79edfd4&scoped=true"
import script from "./abstractCamera.vue?vue&type=script&lang=js"
export * from "./abstractCamera.vue?vue&type=script&lang=js"
import style0 from "./abstractCamera.vue?vue&type=style&index=0&id=a79edfd4&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79edfd4",
  null
  
)

export default component.exports